import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MetaDecorator, Panel, FlexContainer, Flex } from "../../components";

import classnames from "classnames/bind";
import styles from "./Roadmap.module.scss";

const cnb = classnames.bind(styles);

export const Roadmap:React.FunctionComponent<{}> = () => {

  return (
    <>
    <MetaDecorator
      title="Rolling roadmap · Ever Surf"
      description="This is how we go to the moon"
      keywords="ever, surf, token, everscale, utility, bridge, ever, blockchain, community, install, download, app"
    />
    <Container fluid>
      <Row className={cnb("hero")}>
        <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 12 }} xl={{ span: 12 }}>
          <h1 className="header title title-great">Rolling roadmap</h1>
        </Col>
      </Row>
    </Container>
    <Container fluid>
      <FlexContainer
        className={cnb("roadmap")}
        direction={"row"}
        justify={"stretch"}
        align={"flex-start"}
      >
      <Flex grow={1}>
        <Panel
          className={cnb("roadmap-panel", "roadmap-panel-ready")}
          header={<div className={cnb("title", "title-normal")}>Live</div>}
        >
          <a href="https://github.com/EverSurf/contracts/tree/main/multisig2">
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Multisig 2.0</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Everscale</Flex>
            </FlexContainer></a>
          <a href="https://github.com/EverSurf/rust-debot-browser">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Wasm Debot browser</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Debots</Flex>
          </FlexContainer></a>
          <a href="https://vesting.surf">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Vesting Pool</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Vesting</Flex>
          </FlexContainer></a>
          <a href="https://staking.surf/pool/boosted">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Boosted Stake</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Staking</Flex>
          </FlexContainer></a>

          <a href="https://chrome.google.com/webstore/detail/ever-surf-keeper/dfldeefnhahdhaolbkhehhlcgagefgff">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Read-only address</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Extension</Flex>
          </FlexContainer>
          </a>
          <a href="https://ever.surf/download">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Pilot TIP-4 support</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
          </FlexContainer></a>

          <a href="https://staking.surf/pool/gosh">
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Gosh Pool</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Staking</Flex>
            </FlexContainer></a>

          <a href="https://ever.surf/download">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Desktop version</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
          </FlexContainer></a>

          <a href="https://ever.surf/token">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>$SURF pre-launch</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Token</Flex>
          </FlexContainer></a>

          <a href="https://payments.surf/swap">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>Swap tokens</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Payments</Flex>
          </FlexContainer></a>

          <a href="https://ever.surf/download">
          <FlexContainer
            className={cnb("roadmap-panel-row")}
            direction="column"
            justify="flex-start"
            align="stretch"
          >
            <Flex className={cnb("paragraph", "paragraph-normal")}>TIP-3 Support</Flex>
            <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
          </FlexContainer></a>
        </Panel>
      </Flex>

        <Flex grow={1}>
          <Panel
            className={cnb("roadmap-panel")}
            header={<div className={cnb("title", "title-normal")}>To be done</div>}
          >
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Everconnect</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Connect</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Extensions support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Connect</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Metamask support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Connect</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Transfer crypto</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Payments</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Octus Bridge support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Liquid staking solution</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Staking</Flex>
            </FlexContainer>

            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>$SURF launch</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Token</Flex>
            </FlexContainer>

            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Elector 2.0</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Everscale</Flex>
            </FlexContainer>
          </Panel>
        </Flex>

        <Flex grow={1}>
          <Panel
            className={cnb("roadmap-panel")}
            header={<div className={cnb("title", "title-normal")}>Planned</div>}
          >

            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Decentralized Name Service</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>DNS</Flex>
            </FlexContainer>

            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>$SURF CMC listing</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Token</Flex>
            </FlexContainer>

            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Ledger support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Connect</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Security Card relaunch</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Card</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Flex support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
            </FlexContainer>
            <FlexContainer
              className={cnb("roadmap-panel-row")}
              direction="column"
              justify="flex-start"
              align="stretch"
            >
              <Flex className={cnb("paragraph", "paragraph-normal")}>Flat Qube support</Flex>
              <Flex className={cnb("paragraph", "paragraph-small")}>Ever Surf</Flex>
            </FlexContainer>
          </Panel>
        </Flex>
      </FlexContainer>
    </Container>
    </>
  );
};

export default Roadmap;
